<template>
  <div class="wrapper" ref="wrapper">
    <div class="scroll-block-1"
         :class="{ 'active': !isAnimating, 'deactive': isAnimating}">
      <div class="container">

        <div class="banner-schedule">
          9-10 марта <span class="px-3">|</span>
          Инновационный центр Сколково <br>Пространство событий «Матрешка»
        </div>
        <div class="banner-title my-auto py-5">
          <img class="img-fluid" :src="require(`@/assets/Space-Event.svg`)">
          <div class="title">
            ЧЕЛОВЕК 10.0 – КТО ЭТО?
          </div>
        </div>
        <div class="banner-logo">
          <img class="img-fluid" :src="require(`@/assets/header-group.svg`)">
          <img class="img-fluid" :src="require(`@/assets/logo-2-3.svg`)">
        </div>
      </div>
    </div>
    <div class="scroll-block-2"
         :class="{ 'active': isAnimating, 'deactive': !isAnimating }">

      <div class="container justify-content-end">
        <div class="banner-title mb-5">
          ЧЕЛОВЕК 10.0 – КТО ЭТО?
        </div>
        <div class="banner-info">
          <p>
            Куда ведут трансформации?
          </p>
          <p>
            Есть ли финальная точка развития — духовного, материального, личного?
          </p>
          <p>
            Бизнес, наука, духовный мир — противоречие или синергия?
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {ref, onMounted, watch, onUnmounted} from 'vue';

export default {
  name: "BannerMain",
  setup() {
    const isAnimating = ref(false);
    const wrapper = ref(null); // Создаем ссылку на элемент

    const checkScroll = () => {
      // Убедимся, что wrapper.value существует перед вызовом getBoundingClientRect()
      if (wrapper.value) {
        const wrapperRect = wrapper.value.getBoundingClientRect();
        if (wrapperRect.top < window.innerHeight && wrapperRect.bottom > 0) {
          if (wrapperRect.top < 0) {
            isAnimating.value = true;
          } else {
            isAnimating.value = false;
          }
        }
      }
    };

    onMounted(() => {
      window.addEventListener('scroll', checkScroll);
      // Дополнительно, вы можете вызвать checkScroll здесь, чтобы проверить начальное состояние
      checkScroll();
    });

    onUnmounted(() => {
      window.removeEventListener('scroll', checkScroll);
    });

    return {wrapper, isAnimating};
  }
}
</script>


<style lang="scss" scoped>
.banner-logo {
  img {
    max-height: 40px;
  }
}
.banner-schedule {
  font-family: Play, serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 112%;

  br {
    display: none;
  }

  @include _768 {
    font-size: 28px;
    br {
      display: block;
    }
  }
}

.banner-title {
  font-family: Play, serif;

  font-size: 26px;
  font-weight: 700;
  line-height: 30px;
  letter-spacing: 0;

  @include _768 {
    font-size: 78px;
    font-weight: 700;
    line-height: 75px;
  }

  .title {
    font-size: 22px;
    font-weight: 400;
    line-height: 28px;
    letter-spacing: 0;
    text-align: left;
    font-family: 'Museo Sans Cyrl', sans-serif;

    margin-top: 16px;
    @include _768 {
      font-size: 50px;
      font-weight: 400;
      line-height: 64px;
      margin-top: 8px;
    }
  }
}

.banner-info {
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 128%;
  @include _768 {
    font-size: 33px;
  }

  p {
    &:not(:last-child) {
      margin-bottom: 18px;
      @include _768 {
        margin-bottom: 24px;
      }
    }
  }
}

.wrapper {
  position: absolute; /* Изменено с fixed на absolute */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0; /* Это растянет wrapper на всю высоту и ширину header */
  overflow: hidden;
  z-index: 10;

  .scroll-block-1, .scroll-block-2 {
    position: absolute;
    min-height: 100vh;
    width: 100%;
    height: 100%;
    transition: transform 1s ease, opacity 1s ease;
    padding: 60px 0 120px 0;
    @include _576 {
      padding: 30px 0;
    }
    @include _768 {
      padding: 80px 0;
    }

    .container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: baseline;
      height: 100%;
    }
  }

  .scroll-block-1 {
    top: 0;
    left: 0;
    z-index: 1;
    transform: translateY(0);
    opacity: 1;
  }

  .scroll-block-2 {
    top: 0;
    right: 0;
    transform: translateX(100%);
    opacity: 0;
    z-index: 2;
  }

  // Активация анимации
  .scroll-block-1.active {
    transform: translateY(0);
    opacity: 1;
  }

  .scroll-block-2.active {
    transform: translateX(0);
    opacity: 1;
  }

  // Деактивация анимации
  .scroll-block-1.deactive {
    transform: translateY(-100%);
    opacity: 0;
  }

  .scroll-block-2.deactive {
    transform: translateX(100%);
    opacity: 0;
  }
}
</style>